module.exports = __webpack_public_path__ + "static/media/rectangle-12-copy@3x.84b9d928.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/rectangle-12-copy@3x.jpg
// module id = 78
// module chunks = 19